import React from 'react';

import {SupportedLanguage} from '../types';
import {formatDate} from '../utils/dates';

import '../styles/footer.css';

interface FooterProps {
	lang: SupportedLanguage;
}

function Footer({lang}: FooterProps) {
	const copyright =
		lang === 'ar'
			? `
		حقوق النشر محفوظة
		`
			: 'All rights reserved';
	const currentYear = formatDate({
		lang,
		date: new Date().toISOString(),
		dateOptions: {year: 'numeric'},
	});

	return (
		<footer className="Footer">
			<p>{`${copyright} © ${currentYear}`}</p>
		</footer>
	);
}

export default Footer;
